// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"277":"88c66a52","300":"e6f365c5","319":"ec49b674","818":"353db72c"}[chunkId] + ".chunk.css";
};